import { render, staticRenderFns } from "./dashboard_layout.vue?vue&type=template&id=88117b34&"
import script from "./dashboard_layout.vue?vue&type=script&lang=js&"
export * from "./dashboard_layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports